var PikiSanfona;
(function($){

	PikiSanfona = {

		configure : function( el, options ){

			el.$ = el.$ || $( el );

			var defaults = {
				_ : el,
				$ : el.$,
	        	items: '.item',
	        	headers: '.item-trigger',
	        	triggers: false,
	        	contents: '.item-content',
	        	minWidth : false,
	        	breakpoint : false,
	        	canCloseAll : false,
	        	defaultItem : false,
	        	actualItem : false,
	        	beforeOpen : false,
	        	afterInit : false,
	        	style : 'sanfona',
	        	effect : true,
	        	lockHash : false,
	        	effectDuration: 800,
	        	tabs : {
	        		autoSize : false
	        	}
			};
			var data = $.extend({}, defaults, options );

			// Actual style
			data.actualStyle = data.style;

			// Timeout
			data.timeout = false;

			// Se está ativado
			data.enabled = false;

			// Headers
			data.$headers = [];
			
			// Contents
			data.$contents = [];

			// Ítems da sanfona
			data.$items = data.$.find( data.items );
			if( !data.$items.length ){ 
				console.info( 'Sanfona: Não foi encontrado nenhum ítem:' + data.items );
				return; 
			}
			
			// Headers
			data.$headers = data.$items.find( data.headers );
			if( !data.$headers.length ){ 
				console.info( 'Sanfona: Não foi encontrado nenhum header: ' + data.headers );
				return; 
			}

			// Triggers
			data.$triggers = [];
			if( data.triggers !== false ){
				data.$triggers = data.$headers.find( data.triggers );
			}

			// Contents
			data.$contents = data.$items.find( data.contents );
			if( !data.$contents.length ){ 
				console.info( 'Sanfona: Não foi encontrado nenhum conteudo: ' + this.contents );
				return; 
			}

			// Keep data
			data.$.data( 'PikiSanfona', data );

			// Associando os headers aos conteúdos
			data.$items.each(function(i){

				// Content
				this.content = data.$contents.eq( i );
				this.content.get( 0 ).target = data.$items.eq( i );
				
				// Default item
				if( data.defaultItem !== false && i === data.defaultItem ){
					data.$items.eq( i ).addClass( 'default-item' );
				}

				// Header
				this.header = data.$headers.eq( i );				
				this.header.get( 0 ).target = data.$items.eq( i );
				
				// Trigger
				if( data.triggers ){
					this.trigger = data.$triggers.eq( i );
					this.trigger.get( 0 ).target = data.$items.eq( i );
				}

				this.index = i;

			});

			// Se existem links nos headers
			$( 'a', data.$headers ).off( 'click' ).on( 'click.pikiSanfona', function(event){

				event.preventDefault();
				
				// Hash
				if( data.lockHash ) return;

				this.$ = this.$ || $( this );

				// Keep hash
				var hash = this.href.indexOf( '#' > 0 ) ? this.href.split( '#' ).pop() : false;				

				/*
				if( hash !== undefined && hash !== '' ){
				
					var $item = $( hash ).attr( 'id', '' );
					
					window.location.hash = hash;
				
					$item.attr( 'id', hash.substring( 1 ) );
				
				}
				*/

			});

			// Responsive
			$( window ).bind( 'resize', function(){
				PikiSanfona.resizeBind( data );
			});
			PikiSanfona.resize( data, true );

			// Abrindo pela URL
			if( !data.lockHash ){
				var hash = window.location.hash;
				var $item_to_open = data.$items.filter( window.location.hash );
				if( $item_to_open.length ){
					PikiSanfona.toogleItem( data, $item_to_open );
				}
			}

			// Event after init
			if( data.afterInit !== false ){
				data.afterInit( data );
			}

		},

		resize : function( data, initing ){

			var vW = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
			
			// Enable and Disable
			if( data.minWidth !== false ){
				if( vW > data.minWidth && data.enabled === true ){
					PikiSanfona.disable( data );
				}
				else if( vW <= data.minWidth && data.enabled !== true ) {
					PikiSanfona.enable( data );
				}
			}
			else if( data.enabled !== true ){
				PikiSanfona.enable( data );
			}

			// Breakpoint
			if( data.breakpoint !== false ){
				if( vW <= data.breakpoint.width && data.actualStyle != data.breakpoint.style ){
					PikiSanfona.applyStyle( data, data.breakpoint.style );
				}
				else if( vW > data.breakpoint.width && data.actualStyle != data.style ){
					PikiSanfona.applyStyle( data, data.style );
				}
			}

			// Initing - Estilo selecionado
			if( initing === true && data.style == 'abas' ){
				PikiSanfona.applyStyle( data, 'abas' );
			}

		},

		enable : function( data ){

			// Main classes
			data.$.addClass( 'piki-sanfona ' + data.style );

			// Items
			data.$items.addClass( 'sanfona-item' );

			// Headers
			data.$headers.addClass( 'sanfona-header' );
			if( data.$triggers.length ){
				data.$triggers.bind( 'click.pikiSanfona', function(e){
					PikiSanfona.doClick( data, e );
				});
			}
			else {
				data.$headers.bind( 'click.pikiSanfona', function(e){
					PikiSanfona.doClick( data, e );
				});
			}

			// Contents
			data.$contents.addClass( 'sanfona-content' );
			data.$contents.hide();

			// Reabre o ítem que já estava aberto
			data.$items.filter( '.opened' ).find( data.contents ).show();
			
			// Status
			data.enabled = true;
		
		},

		disable : function( data ){
			
			// Main classes
			data.$.removeClass( 'piki-sanfona ' + data.style );

			// Items
			data.$items.removeClass( 'sanfona-item' );
			
			// Headers
			data.$headers.unbind( '.pikiSanfona' );
			data.$headers.removeClass( 'sanfona-header' );

			// Contents
			data.$contents.show();
			data.$contents.removeClass( 'sanfona-content' );

			// Status
			data.enabled = false;
						
		},

		applyStyle : function( data, style ){
				
			data.$.removeClass( 'sanfona abas' ).addClass( style );

			if( style == 'abas'  ){

				// Removendo ícones
				data.$headers.each(function(){
					this.$ = this.$ || $( this );
					this.$.find( 'i.ico' ).remove();
				});
				
				data.$navigation_wrapper = $( '<div class="sanfona-controls pkslider '+ ( data.tabs.autoSize ? 'auto-size' : '' ) +'"></div>' ).prependTo( data.$ );
				data.$navigation = $( '<ul></ul>' ).prependTo( data.$navigation_wrapper );
				data.$headers.each(function(){
					this.$ = this.$ || $( this );
					var newTab = $( '<li></li>' ).appendTo( data.$navigation );
					this.$.appendTo( newTab );
				});
				data.$.addClass( 'abas' )
				data.actualStyle = 'abas';

				// Sempre com um ítem aberto
				var opened = data.$items.filter( '.opened' );
				if( !opened.length && !data.canCloseAll ){
					PikiSanfona.toogleItem( data, data.$items.eq( data.defaultItem !== false ? data.defaultItem : 0 ) );
				}
			
			}
			else if( style == 'sanfona' && data.actualStyle == 'abas' ){

				// Posicionando e adicionando ícones
				data.$headers.each(function(){
					this.$ = this.$ || $( this );
					this.$.append( '<i class="ico"></i>' );
					this.$.prependTo( this.target );
				});

				if( data.$navigation_wrapper.length ){
					data.$navigation_wrapper.remove();
				}

				data.$.addClass( 'sanfona' );
				
				data.actualStyle = 'sanfona';
			
			}

			// Callback after change style
			if( data.breakpoint !== false && data.breakpoint.callback !== undefined ){
				data.breakpoint.callback.call( data._ );
			}

		},

		resizeBind : function( data ){
			clearTimeout( data.timeout );
			data.timeout = setTimeout(function(){
				PikiSanfona.resize( data );
			}, 200 );
		},

		doClick : function( data, event ){
			var $item = event.delegateTarget.target;
			PikiSanfona.toogleItem( data, $item );
		},

		closeAll : function( data ){
			
			data.$items.removeClass( 'opened' );
			data.$headers.removeClass( 'opened' );

			if( data.defaultItem !== false ){
				// Open default ítem
				$item = data.$items.eq( data.defaultItem );
				PikiSanfona.openItem( data, $item );
			}

			// Close others items
			PikiSanfona.closeOthers( data );

		},

		openItem : function( data, $item ){

			var _item = $item.get( 0 );

			// Keep actual item
			data.actualItem = _item;

			// Callback before open
			if( data.beforeOpen !== false ){
				data.beforeOpen( data, $item );
			}
			
			$item.addClass( 'opened' );
			_item.header.addClass( 'opened' );
			_item.content.stop( true, true );

			if( data.effect === 'fade' ){

				_item.content.fadeIn( data.effectDuration, function(){
					// Callback after open
					if( data.onOpen !== undefined ){
						data.onOpen.call( this, data._ );
					}
				});

			}
			else {

				_item.content.slideDown( data.effectDuration, function(){
					// Callback after open
					if( data.onOpen !== undefined ){
						//data.onOpen.call( this, data._ );
					}
				});
			
			}

		},

		toogleItem : function( data, $item ){
			
			var clicked = $item.get( 0 );
			var isOpened = $item.hasClass( 'opened' );
			var isDefault = $item.hasClass( 'default-item' );

			if( ( data.actualStyle == 'abas' && isOpened === true && data.canCloseAll === false && data.defaultItem === false ) || ( isOpened && isDefault ) ){
				return;
			}

			data.$items.removeClass( 'opened' );
			data.$headers.removeClass( 'opened' );
			
			if( !isOpened || ( !isDefault && data.defaultItem !== false ) ){
				
				// Open default ítem
				if( isOpened ){
					$item = data.$items.eq( data.defaultItem );
					clicked = $item.get( 0 );
				}

				// Keep actual item
				data.actualItem = clicked;

				PikiSanfona.openItem( data, $item );
			
			}

			// Close others items
			PikiSanfona.closeOthers( data );

		},

		// Close others items
		closeOthers : function( data ){
			// Fecha os outros
			data.$items.not( '.opened' ).each(function(){
				this.content.stop( true, true );
				if( data.effect === 'fade' ){
					this.content.fadeOut( data.effectDuration );
				}
				else {
					this.content.slideUp( data.effectDuration );
				}
			});
		}
	
	};

	// Sanfona
	$.fn.pikiSanfona = function( method ){

		var pluginArgs = arguments;

		return this.each(function(){

			this.$ = this.$ || $( this );

			// Chamando os métodos
			var toCall;
			if( typeof method === 'object' && this.ready === undefined ){
				PikiSanfona.configure( this, method );
			}
			else if( typeof method === 'string' && ( toCall = eval( "this."+method ) ) !== undefined ){
				var data = this.$.data( 'PikiSanfona' );
				PikiSanfona.toCall( data, Array.prototype.slice.call( pluginArgs, 1 ) );
			}

		});

	};

})(jQuery);	
